import { all, put, select, takeEvery } from 'redux-saga/effects';
import { adjust, assoc, findIndex, propEq } from 'ramda';

import {
    getProjectListSettings,
    getWorksheetListSettings,
    getProjectMassListSettings,
    getWorksheetMassListSettings,
    postProjectListColumnWidth,
    postWorksheetListColumnWidth,
    postProjectMassListColumnWidth,
    postWorksheetMassListColumnWidth,
    postProjectListSettings,
    postWorksheetListSettings,
    postProjectMassListSettings,
    postWorksheetMassListSettings
} from 'actions/asyncActions';

import * as actions from 'constants/actionTypes';

const updateSettingsFieldWidth = (settings, fieldName, fieldWidth) => {
    const fieldIndex = findIndex(propEq('name', fieldName), settings.fields);
    return assoc('fields', adjust(fieldIndex, assoc('width', fieldWidth), settings.fields), settings);
};

const createSettingsSaga = (asyncDataAction, postAction, postColumn, POST_SETTINGS, POST_COLUMN, SET_COLUMN ) => {
    function* updateSettings({ payload }) {
        yield put(asyncDataAction.success(payload));
    }

    function* updateColumn(action) {
        const { columnName, columnWidth } = action.payload;
        const settings = yield select(state => asyncDataAction.selectData(state));
        const newSettings = updateSettingsFieldWidth(settings, columnName, columnWidth);
        yield put(asyncDataAction.success(newSettings));
        yield put(postColumn(newSettings));
    }

    return function* () {
        yield all([
            takeEvery(SET_COLUMN, updateColumn),
            takeEvery(POST_SETTINGS, updateSettings)
        ]);
    };
};

export const projectSettings = createSettingsSaga(
    getProjectListSettings,
    postProjectListSettings,
    postProjectListColumnWidth,
    actions.POST_PROJECT_LIST_SETTINGS,
    actions.POST_PROJECT_LIST_COLUMN_WIDTH,
    actions.SET_PROJECT_LIST_COLUMN_WIDTH
);
export const worksheetSettings = createSettingsSaga(
    getWorksheetListSettings,
    postWorksheetListSettings,
    postWorksheetListColumnWidth,
    actions.POST_WORKSHEET_LIST_SETTINGS,
    actions.POST_WORKSHEET_LIST_COLUMN_WIDTH,
    actions.SET_WORKSHEET_LIST_COLUMN_WIDTH
);

export const projectMassSettings = createSettingsSaga(
    getProjectMassListSettings,
    postProjectMassListSettings,
    postProjectMassListColumnWidth,
    actions.POST_PROJECT_MASS_LIST_SETTINGS,
    actions.POST_PROJECT_MASS_LIST_COLUMN_WIDTH,
    actions.SET_PROJECT_MASS_LIST_COLUMN_WIDTH
);

export const worksheetMassSettings = createSettingsSaga(
    getWorksheetMassListSettings,
    postWorksheetMassListSettings,
    postWorksheetMassListColumnWidth,
    actions.POST_WORKSHEET_MASS_LIST_SETTINGS,
    actions.POST_WORKSHEET_MASS_LIST_COLUMN_WIDTH,
    actions.SET_WORKSHEET_MASS_LIST_COLUMN_WIDTH
);
